import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
} from '@angular/core';
import {
  ChessboardFun,
  chessBoard,
  clearCanvas,
  drawArrow,
  initializeCanvas,
  rotateChess,
} from '../../../shared/functions/chessboardMain';
import { game } from '../../../shared/functions/chess';
import {
  apiFlagBV,
  highlightLastMove,
  resetChess,
  undoMove,
  updateBoard,
} from '../../../shared/functions/onDrop';
import { CommonModule } from '@angular/common';
import { ProplayerService } from '../../../shared/services/proplayer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PieceIconPipe } from '../../../shared/pipes/piece-icon.pipe';
import { DecryptionService } from '../../../shared/services/decryption.service';

@Component({
  selector: 'app-opening-details',
  standalone: true,
  templateUrl: './opening-details.component.html',
  styleUrl: './opening-details.component.scss',
  imports: [CommonModule, PieceIconPipe],
})
export class OpeningDetailsComponent implements OnInit, AfterViewInit {
  currentMoveIndex = 0;
  pageNumber = 1;
  recordDataMove: any;
  historyGameMove!: string[];
  playerGames: any;
  lastIndexGame: any;
  openingIdpagedata: any;
  leastopeningMoveData: any;
  leastopeningIdMoveData: any[] = [];
  openingIDdata: any[] = [];
  isLoading = false;
  letestMove: any;
  newLetestMove: any[] = [];
  openingTitle: any;
  openingMove: any;
  openingEco: any;
  chessShowclass = 'col-md-5';
  variationsData: any[] = [];
  constructor(
    private openingApi: ProplayerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private elRef: ElementRef,
    private decryptionApi: DecryptionService
  ) {}

  ngOnInit(): void {
    this.playerGames = this.activatedRoute.snapshot.paramMap.get('id');

    if (this.playerGames) {
      apiFlagBV.subscribe((res) => {
        if (res) {
          this.newOpeningdata();
        }
      });
    }
  }

  ngAfterViewInit(): void {
    ChessboardFun();
    resetChess();

    this.openingStartData();
    initializeCanvas(this.elRef);
  }

  openingStartData() {
    this.openingApi
      .openingIdData({ page: this.pageNumber, gameId: this.playerGames })
      .subscribe({
        next: (res) => {
          const decrypt = this.decryptionApi.decrypt(res.payload);
          const jsondecrpt = JSON.parse(decrypt);
          this.variationsData = jsondecrpt.variations;
          this.leastopeningMoveData = jsondecrpt.opening;
          this.recordDataMove = jsondecrpt.opening[0];
          this.openingTitle = this.recordDataMove.name;
          this.openingEco = this.recordDataMove.eco;
          this.openingIdpagedata = jsondecrpt.data;

          if (this.openingIdpagedata.length > 0) {
            this.chessShowclass = 'col-md-5';
          } else {
            this.chessShowclass = 'col-md-12';
          }
          this.historyGameMove = this.parsePGN(this.recordDataMove.pgn);
          this.lastIndexGame = this.historyGameMove?.length;
          this.currentMoveIndex = this.lastIndexGame;
          this.openingIDdata.push(...this.openingIdpagedata);
          game.loadPgn(this.recordDataMove.pgn);
          chessBoard.position(game.fen());
          updateBoard();
          this.openingMove = game.pgn();
        },
      });
  }

  openingSelectData() {
    this.isLoading = true;
    this.openingApi
      .openingIdData({ page: this.pageNumber, move: game.pgn() })
      .subscribe({
        next: (res) => {
          const decrypt = this.decryptionApi.decrypt(res.payload);
          const jsondecrpt = JSON.parse(decrypt);
          this.leastopeningMoveData = jsondecrpt.opening;
          this.openingIdpagedata = jsondecrpt.data;
          this.isLoading = !this.openingIdpagedata;
          this.letestMove = this.recordDataMove.pgn;
          this.openingIDdata.push(...this.openingIdpagedata);
        },
      });
  }

  newOpeningdata() {
    this.openingIDdata = [];
    this.leastopeningMoveData = [];
    this.pageNumber = 1;
    this.historyGameMove = this.parsePGN(game.pgn());
    this.lastIndexGame = this.historyGameMove?.length;
    this.currentMoveIndex = this.lastIndexGame;
    chessBoard.position(game.fen());
    this.openingMove = game.pgn();

    this.openingApi
      .openingIdData({ page: this.pageNumber, move: game.pgn() })
      .subscribe({
        next: (res) => {
          const decrypt = this.decryptionApi.decrypt(res.payload);
          const jsondecrpt = JSON.parse(decrypt);
          this.variationsData = [];
          this.leastopeningMoveData = jsondecrpt.opening;
          this.openingIdpagedata = jsondecrpt.data;
          this.isLoading = !this.openingIdpagedata;
          this.letestMove = this.recordDataMove.pgn;
          this.openingIDdata.push(...this.openingIdpagedata);
        },
      });
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    event.stopPropagation();
    if (event.key === 'ArrowLeft' || event.key === 'F' || event.key === 'f') {
      event.preventDefault();
      if (event.key === 'ArrowLeft') {
        this.prevMove();
      } else if (event.key === 'F' || event.key === 'f') {
        this.filpChessBoard();
      }
    }
  }

  parsePGN(pgn: string): string[] {
    const movesArray: string[] = [];
    const moves = pgn.split(/\d+\./).slice(1);

    for (let move of moves) {
      const moveSequence = move.trim().split(/\s+/);
      for (let singleMove of moveSequence) {
        if (singleMove.trim() !== '') {
          movesArray.push(singleMove);
        }
      }
    }
    return movesArray;
  }

  prevMove() {
    if (this.currentMoveIndex > 0) {
      this.currentMoveIndex--;
      undoMove();
      clearCanvas();
      updateBoard();
      this.newOpeningdata();
    }
  }

  filpChessBoard() {
    rotateChess();
  }

  onScroll(event: any) {
    const element = event.target as HTMLElement;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const totalHeight = element.scrollHeight;
    if (
      this.openingIdpagedata.length == 0 ||
      this.openingIdpagedata.length < 20
    ) {
      return;
    }

    if (scrollPosition >= totalHeight - 1 && !this.isLoading) {
      this.isLoading = true;
      this.pageNumber++;
      this.openingSelectData();
    }
  }

  recondIddata(id: number) {
    this.router.navigate(['historyboard', id]);
  }

  tablepgn(data: any) {
    game.move(data.move);
    this.openingTitle = data.name;
    this.openingEco = data.eco;
    chessBoard.position(game.fen());
    this.newOpeningdata();
  }

  moveHoverData(data: any) {
    // clearCanvas();
    highlightLastMove(data.from, data.to);
    drawArrow(data.from, data.to);
  }

  variationsSelectData(data: any) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.navigate(['openingdetails', data._id]);
    this.openingStartData();
  }

  mainMenu() {
    this.router.navigate(['openings']);
  }
}
